module.exports = __webpack_public_path__ + "bffea16c1976c8d2a6d9c08dea8dcadd.jpg";